import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Globe, Target } from 'lucide-react';
import { aboutContent } from '../data/mock';

const AboutSection = () => {
  const features = [
    { icon: Building2, label: 'London Headquarters', desc: 'Global reach from our base' },
    { icon: Globe, label: 'International Operations', desc: 'Serving clients worldwide' },
    { icon: Target, label: 'Strategic Focus', desc: 'Results-driven approach' }
  ];

  return (
    <section className="section" id="about" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="caption mb-4 inline-block" style={{ color: 'var(--accent-primary)' }}>
              About Us
            </span>
            <h2 className="heading-1 mb-6">{aboutContent.title}</h2>
            
            <div className="space-y-4">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="body-medium">
                  {paragraph}
                </p>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid gap-4"
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="card flex items-center gap-4"
              >
                <div className="icon-container">
                  <feature.icon size={20} />
                </div>
                <div>
                  <h3 className="heading-3 mb-1">{feature.label}</h3>
                  <p className="body-small">{feature.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
